// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import echarts from 'echarts';
import "element-ui/lib/theme-chalk/index.css";
import Axios from 'axios'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

// Axios.defaults.baseURL='http://192.168.50.121:5000/cmbp/api/v1.0'

Vue.prototype.$echarts = echarts //引入组件
import VueVideoPlayer from 'vue-video-player';
import 'video.js/dist/video-js.css';
// import 'videojs-flash';
import 'vue-video-player/src/custom-theme.css'
import 'videojs-contrib-hls'
// import 'videojs-contrib-hls/dist/videojs-contrib-hls';
Vue.use(VueVideoPlayer)
Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.$http=Axios
Vue.use(VueAwesomeSwiper, /* { default global options } */)

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});


// WEBPACK FOOTER //
// ./src/main.js